const phoneUtil = require("google-libphonenumber").PhoneNumberUtil.getInstance();
const validate = (values, props) => {
  const errors = {};
  if (!values.date) {
    errors.date = "Required";
  }
  if (!values.time) {
    errors.time = "Required";
  }
  if (!values.adults) {
    errors.adults = "Required";
  }
  if (!values.children && values.children !== "0" && values.children !== 0) {
    errors.children = "Required";
  }
  if (!values.skiSnowboards) {
    errors.skiSnowboards = "Required";
  }
  if (!values.bikesSurfboards) {
    errors.bikesSurfboards = "Required";
  }
  if (!values.holdLuggage) {
    errors.holdLuggage = "Required";
  }

  if (props.transfers.showFlightNumber && !values.flightNumber) {
    errors.flightNumber = "Required";
  }
  if (props.transfers.fromAccommodation.show && !values.accommodationName) {
    errors.accommodationName = "Required";
  }
  if (props.transfers.toAccommodation.show && !values.toAccommodationName) {
    errors.toAccommodationName = "Required";
  }

  for (var i = 0; i < props.children; i++) {
    if (!values[`childAge${i}`]) {
      errors[`childAge${i}`] = "Required";
    }
    if (values[`childAge${i}`] > 15 || values[`childAge${i}`] < 0) {
      errors[`childAge${i}`] = "Age must be between 0 and 15";
    }
    if (!values[`seatType${i}`]) {
      errors[`seatType${i}`] = "Required";
    }
  }
  if (props.transfers.shuttle.showTimes && !values.busNumber) {
    errors.busNumber = "Required";
  }
  if (!values.transferType) {
    errors.transferType = "Required";
  }
  if (props.transfers.shuttle.showFrom && !values.departureStop) {
    errors.departureStop = "Required";
  }
  if (props.transfers.shuttle.showTo && !values.arrivalStop) {
    errors.arrivalStop = "Required";
  }

  if (!values.firstName || !/^[a-zA-Z ]*$/g.test(values.firstName)) {
    errors.firstName = "Please enter your first name (text only)";
  }

  if (!values.lastName || !/^[a-zA-Z ]*$/g.test(values.lastName)) {
    errors.lastName = "Please enter your last name (text only)";
  }
  if (!values.email) {
    errors.email = "Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Please enter a valid email address";
  }
  try {
    const number = phoneUtil.parse(values.phone);

    if (
      !phoneUtil.isPossibleNumber(number) ||
      !phoneUtil.isValidNumber(number)
    ) {
      errors.phone =
        "Please enter a valid phone number including country code e.g. +447900123456";
    }
  } catch (error) {
    if (error && error.message) {
      errors.phone = error.message.replace(/string/gi, "number");
    }
  }
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/containers/QuotePage/YourSummaryPanel/form/validate.js